import './styles.scss';

const FullWidthFilterBar = (props) => {
  const { containerClassName } = props;
  return (
    <div
      className={`container-offset full-width-filter-bar filter-bar-border-top filter-bar-border-bottom ${
        containerClassName ? containerClassName : ''
      }`}
    >
      {props.children}
    </div>
  );
};

export default FullWidthFilterBar;
